import { gameErrorsReducer } from './game';
import { roomErrorsReducer } from './room';
import { combineReducers } from "redux";

const errorsReducer = combineReducers({
    room: roomErrorsReducer,
    game: gameErrorsReducer
});

export default errorsReducer;